import React from 'react'
import { KlarnaLogoFull } from '@klarna/bubble-ui'
import backgroundPattern from './background-pattern.svg'

export default {
  issuerName: 'Klarna',
  darkLogo: props => <KlarnaLogoFull {...props} gray />,
  lightLogo: props => <KlarnaLogoFull {...props} inverse />,
  backgroundFallback: backgroundPattern
}
